import { Button } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { baseUrl } from "../../Config/baseUrl";
import { toast } from "react-toastify";

const Project = () => {
  const { id } = useParams();
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  const getCreer = () => {
    axios
      .get(`${baseUrl}/blog/project-api/`, {
        headers: {
          Authorization: `Token ${localStorage.getItem("token")}`,
          "Access-Control-Allow-Origin": "*",
        },
      })
      .then((res) => {
        setData(res?.data?.data || []);
      })
      .catch(() => {
        toast.error("Failed to load projects");
      });
  };

  const deleteFAQ = (ids) => {
    const formData = new FormData();
    formData.append("project_id", ids);

    axios
      .delete(`${baseUrl}/blog/project-api/`, {
        headers: {
          Authorization: `Token ${localStorage.getItem("token")}`,
          "Access-Control-Allow-Origin": "*",
        },
        data: formData,
      })
      .then((res) => {
        toast.success(res?.data?.message || "Project deleted");
        getCreer();
      })
      .catch(() => {
        toast.error("Error deleting project");
      });
  };

  useEffect(() => {
    getCreer();
  }, []);

  return (
    <div className="w-full min-h-screen px-1 py-0.5">
      {/* Header */}
      <p className="my-4 sm:my-0 text-3xl sm:text-4xl lg:text-5xl text-center text-blue-900 underline">
        Project
      </p>

      {/* Add Button */}
      <div className="flex justify-end mb-2">
        <NavLink to="/project/add">
          <Button variant="outlined">Add</Button>
        </NavLink>
      </div>

      {/* Grid */}
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {data.map((item) => (
          <div
            key={item.id}
            className="flex flex-col h-full p-4 bg-white border border-gray-300 rounded-lg shadow-md"
          >
            {/* Title */}
            <p className="mb-3 text-lg sm:text-xl font-semibold text-black break-words underline">
              {item.title}
            </p>

            {/* Image */}
            {item?.image && (
              <img
                src={item.image}
                alt={item.title}
                className="w-full h-48 mb-4 object-cover rounded-md"
              />
            )}

            {/* Buttons */}
            <div className="flex flex-wrap justify-center gap-4 mt-auto">
              <Button
                className="w-full sm:w-auto"
                onClick={() =>
                  navigate("/project/update", {
                    state: item.id,
                  })
                }
                variant="outlined"
              >
                Update
              </Button>

              <Button
                className="w-full sm:w-auto"
                onClick={() => deleteFAQ(item.id)}
                variant="outlined"
                color="error"
              >
                Delete
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Project;
